import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { toNum } from '@shared/helpers/math.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { occasioniLavoroInvalidMessage, offertaBeniInvalidMessage } from '../common/consts/validation-message.const';
import { getSchedaPrevalenzaGroup, schedaPrevalenzaCommHelper, schedaPrevalenzaValuesHelper } from './helpers/natura-mutualistica-form-validators.helper';

export const naturaMutualisticaSchedaPrevalenzaA1B9Rules: FormGroupRules = {
    my_CoopInattivaCommPrimoAnno: (form: FormGroup) => {
        const schedaPrevalenzaGroup = getSchedaPrevalenzaGroup(form);
        const my_CoopInattivaCommPrimoAnnoControl = getControl(schedaPrevalenzaGroup, 'my_CoopInattivaCommPrimoAnno');
        const my_CkOffreBeniServCoopAttPrimoAnno = toNum(getControl(schedaPrevalenzaGroup, 'my_CkOffreBeniServCoopAttPrimoAnno')?.value);
        const my_CkOffreOccLavSociCoopAttPrimoAnno = toNum(getControl(schedaPrevalenzaGroup, 'my_CkOffreOccLavSociCoopAttPrimoAnno')?.value);
        const my_CkRemunConferProdSociCoopAttPrimoAnno = toNum(getControl(schedaPrevalenzaGroup, 'my_CkRemunConferProdSociCoopAttPrimoAnno')?.value);
        const my_CkRemunPrestConfServSociCoopAttPrimoAnno = toNum(getControl(schedaPrevalenzaGroup, 'my_CkRemunPrestConfServSociCoopAttPrimoAnno')?.value);
        const my_TotaleA1NonModifPrimoAnno = toNum(getControl(schedaPrevalenzaGroup, 'my_TotaleA1NonModifPrimoAnno')?.value);
        const errors = my_CoopInattivaCommPrimoAnnoControl.errors ? my_CoopInattivaCommPrimoAnnoControl.errors : {};
        const showError =
            isNilOrEmpty(my_CoopInattivaCommPrimoAnnoControl?.value) &&
            my_TotaleA1NonModifPrimoAnno > 0 &&
            my_CkOffreBeniServCoopAttPrimoAnno === 0 &&
            my_CkOffreOccLavSociCoopAttPrimoAnno === 0 &&
            my_CkRemunConferProdSociCoopAttPrimoAnno === 0 &&
            my_CkRemunPrestConfServSociCoopAttPrimoAnno === 0;

        addRemoveError(showError, errors, 'my_CoopInattivaCommPrimoAnno', { status: REQUIRED_STATUS });
        my_CoopInattivaCommPrimoAnnoControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CoopInattivaComm: (form: FormGroup) => {
        const schedaPrevalenzaGroup = getSchedaPrevalenzaGroup(form);
        const my_CoopInattivaCommControl = getControl(schedaPrevalenzaGroup, 'my_CoopInattivaComm');
        const my_CkOffreBeniServCoopAtt = toNum(getControl(schedaPrevalenzaGroup, 'my_CkOffreBeniServCoopAtt')?.value);
        const my_CkOffreOccLavSociCoopAtt = toNum(getControl(schedaPrevalenzaGroup, 'my_CkOffreOccLavSociCoopAtt')?.value);
        const my_CkRemunConferProdSociCoopAtt = toNum(getControl(schedaPrevalenzaGroup, 'my_CkRemunConferProdSociCoopAtt')?.value);
        const my_CkRemunPrestConfServSociCoopAtt = toNum(getControl(schedaPrevalenzaGroup, 'my_CkRemunPrestConfServSociCoopAtt')?.value);
        const my_TotaleA1NonModif = toNum(getControl(schedaPrevalenzaGroup, 'my_TotaleA1NonModif')?.value);
        const errors = my_CoopInattivaCommControl.errors ? my_CoopInattivaCommControl.errors : {};
        const showError =
            isNilOrEmpty(my_CoopInattivaCommControl?.value) &&
            my_TotaleA1NonModif > 0 &&
            my_CkRemunPrestConfServSociCoopAtt === 0 &&
            my_CkRemunConferProdSociCoopAtt === 0 &&
            my_CkOffreOccLavSociCoopAtt === 0 &&
            my_CkOffreBeniServCoopAtt === 0;

        addRemoveError(showError, errors, 'my_CoopInattivaComm', { status: REQUIRED_STATUS });
        my_CoopInattivaCommControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_A1versoSociPrimoAnno: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(
            form,
            'my_A1versoSociPrimoAnno',
            'my_CkOffreBeniServ',
            'my_CkOffreBeniServCoopAttPrimoAnno',
            'my_TotaleA1PrimoAnno',
            'my_BilAnno1',
            'A1',
            offertaBeniInvalidMessage
        );
    },

    my_A1versoSoci: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(form, 'my_A1versoSoci', 'my_CkOffreBeniServ', 'my_CkOffreBeniServCoopAtt', 'my_TotaleA1', 'my_BilAnno2', 'A1', offertaBeniInvalidMessage);
    },

    my_TotaleA1: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(form, 'my_TotaleA1', 'my_CkOffreBeniServ', 'my_CkOffreBeniServCoopAtt', null, 'my_BilAnno2', 'A1', offertaBeniInvalidMessage, true);
    },

    my_TotaleA1PrimoAnno: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(
            form,
            'my_TotaleA1PrimoAnno',
            'my_CkOffreBeniServ',
            'my_CkOffreBeniServCoopAttPrimoAnno',
            null,
            'my_BilAnno1',
            'A1',
            offertaBeniInvalidMessage,
            true
        );
    },

    my_OffreBeniServCommPrimoAnno: (form: FormGroup) => {
        schedaPrevalenzaCommHelper(form, 'my_OffreBeniServCommPrimoAnno', 'my_CkOffreBeniServ', 'my_A1versoSociPrimoAnno', 'my_TotaleA1PrimoAnno', 'my_TotaleA1NonModifPrimoAnno');
    },

    my_OffreBeniServComm: (form: FormGroup) => {
        schedaPrevalenzaCommHelper(form, 'my_OffreBeniServComm', undefined, 'my_A1versoSoci', 'my_TotaleA1', 'my_TotaleA1NonModif');
    },

    my_B9versoSociPrimoAnno: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(
            form,
            'my_B9versoSociPrimoAnno',
            'my_CkOffreOccLavSoci',
            'my_CkOffreOccLavSociCoopAttPrimoAnno',
            'my_TotaleB9PrimoAnno',
            'my_BilAnno1',
            'B9',
            occasioniLavoroInvalidMessage
        );
    },

    my_B9versoSoci: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(
            form,
            'my_B9versoSoci',
            'my_CkOffreOccLavSoci',
            'my_CkOffreOccLavSociCoopAtt',
            'my_TotaleB9',
            'my_BilAnno2',
            'B9',
            occasioniLavoroInvalidMessage
        );
    },

    my_TotaleB9PrimoAnno: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(
            form,
            'my_TotaleB9PrimoAnno',
            'my_CkOffreOccLavSoci',
            'my_CkOffreOccLavSociCoopAttPrimoAnno',
            null,
            'my_BilAnno1',
            'B9',
            occasioniLavoroInvalidMessage,
            true
        );
    },

    my_TotaleB9: (form: FormGroup) => {
        schedaPrevalenzaValuesHelper(form, 'my_TotaleB9', 'my_CkOffreOccLavSoci', 'my_CkOffreOccLavSociCoopAtt', null, 'my_BilAnno1', 'B9', occasioniLavoroInvalidMessage, true);
    },

    my_OffreOccLavSociCommPrimoAnno: (form: FormGroup) => {
        schedaPrevalenzaCommHelper(
            form,
            'my_OffreOccLavSociCommPrimoAnno',
            undefined,
            'my_B9versoSociPrimoAnno',
            'my_TotaleB9PrimoAnno',
            'my_TotaleB9NonModifPrimoAnno'
        );
    },

    my_OffreOccLavSociComm: (form: FormGroup) => {
        schedaPrevalenzaCommHelper(form, 'my_OffreOccLavSociComm', undefined, 'my_B9versoSoci', 'my_TotaleB9', 'my_TotaleB9NonModif');
    },
};
